import { Flp360StatusEnum } from '../enums';
import { BaseSettings } from 'src/app/common/component-settings/base-settings.model';
export class Flp360LoginComponentSettings extends BaseSettings {
    constructor() {
        super(...arguments);
        this.flp360StatusEnum = Flp360StatusEnum;
    }
}
